import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { getEndMenu, setPositionY } from '../../modules/reducerDimensions'

import Slider from 'rc-slider'
import 'rc-slider/assets/index.css'
import './MenuSlider.css'

const MenuSlider = ({ visible }) => {
  const dispatch = useDispatch()
  const end = useSelector(getEndMenu)
  const sliderY = useSelector(state => state.dimensions.sliderY)

  return (
    <div className="slider-container">
      <Slider
        onChange={e => {
          if (visible) {
            dispatch(setPositionY(((100 - e) * end) / 100))
          }
        }}
        vertical
        min={0}
        max={100}
        step={1}
        defaultValue={100}
        value={100 - (100 * sliderY) / end}
      />
    </div>
  )
}

export default MenuSlider
